export const SET_SERVER_MODE = 'connect/SET_SERVER_MODE';
export const SET_PLAYER_FILTER = 'connect/SET_PLAYER_FILTER';
export const SET_GAME_MODE = 'connect/SET_GAME_MODE';
export const SET_CLAN_MODE = 'connect/SET_CLAN_MODE';
export const SET_AGE_FILTER = 'connect/SET_AGE_FILTER';
export const SET_PAGE_VALUE = 'connect/SET_PAGE_VALUE';
